import { Logos } from '@app/src/wf-constants'
import React from 'react'

const WorldfavorLogo: React.FC = () => (
  <img src={Logos.WorldfavorLogoSquareFilledBlack} alt="Worldfavor" style={{ height: 32, borderRadius: 4 }} />
)

export default WorldfavorLogo
